import { configureStore } from "@reduxjs/toolkit";
import galleryReducer from "./GalleryRedux";
import OTPReducer from "./OTPRedux";
import LoginReducer from "./LoginRedux";
import GlobalStatusReducer from "./GlobalStatusRedux";
import AddToCartReducer from "./AddToCartRedux";
import CartReducer from "./CartRedux";
import OrderReducer from "./OrderRedux";
import UpdateGalleryReducer from "./UpdateGallery";
import AddressDetailsReducer from "./AddressDetailsRedux";
import ConfirmOrderReducer from "./ConfirmOrderRedux"
import RequestOrderReducer from "./OrderDetailRedux"
import galleryUIDReducer from "./GalleryUIDRedux"
import CustomerOrdersReducer from "./CustomerOrdersRedux";
import RequestCustomerOrdersReducer from "./CustomerOrdersDetailRedux"
import UpdateCustomerReducer from "./UpdateCustomerStatusRedux"

export const store = configureStore({
  reducer: {
    gallery: galleryReducer,
    galleryUID:galleryUIDReducer,
    OTP: OTPReducer,
    Login: LoginReducer,
    GlobalStatus: GlobalStatusReducer,
    AddToCart: AddToCartReducer,
    Cart: CartReducer,
    UpdateGallery: UpdateGalleryReducer,
    AddressDetails:AddressDetailsReducer,
    ConfirmOrder:ConfirmOrderReducer,
    Order: OrderReducer,
    CustomerOrders: CustomerOrdersReducer,
    RequestOrder:RequestOrderReducer,
    RequestCustomerOrders:RequestCustomerOrdersReducer,
    UpdateCustomer:UpdateCustomerReducer,
  },
});
